import React, {
    useState, useEffect, useCallback,
} from 'react';
import axios from 'axios';
import Button from '../../../common/button/Button';

const UpdateBarComponent = () => {
    const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);
    const [bundleJSUrl, setBundleJSUrl] = useState(undefined);
    const [vendorsJSUrl, setVendorsJSUrl] = useState(undefined);
    const [bundleCSSUrl, setBundleCSSUrl] = useState(undefined);

    const appUpdateTime = 1000 * 60 * 23; // 23 minutos
    const offlineCheckTime = 1000 * 60 * 2; // 2 minutos

    const checkForUpdate = useCallback(() => {
        if (navigator.onLine && bundleJSUrl && vendorsJSUrl && bundleCSSUrl) {
            const FYC = Math.floor(Date.now() / 1000 / 60 / 5);

            axios.all([
                axios.head(`${bundleJSUrl}?FYC=${FYC}`),
                axios.head(`${vendorsJSUrl}?FYC=${FYC}`),
                axios.head(`${bundleCSSUrl}?FYC=${FYC}`),
            ])
                .then(() => {
                    setTimeout(checkForUpdate, appUpdateTime);
                })
                .catch(() => {
                    setIsUpdateAvailable(true);
                });
        } else {
            setTimeout(checkForUpdate, offlineCheckTime);
        }
    }, [bundleJSUrl, vendorsJSUrl, bundleCSSUrl, appUpdateTime, offlineCheckTime]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const bundleEl = document.getElementById('bundleJS');
            const vendorsEl = document.getElementById('vendorsJS');
            const bundleCssEl = document.getElementById('bundleCSS');

            if (bundleEl && vendorsEl && bundleCssEl) {
                setBundleJSUrl(bundleEl.src);

                setVendorsJSUrl(vendorsEl.src);

                setBundleCSSUrl(bundleCssEl.href);
            }

            const timer = setTimeout(checkForUpdate, appUpdateTime);

            return () => clearTimeout(timer);
        }
    }, [appUpdateTime, checkForUpdate]);


    if (isUpdateAvailable) {
        return (
            <div className="updateBar">
                <Button
                    className="buttonUpdate"
                    onClick={() => window.location.reload()}
                    title="Atualização disponível"
                >
                    <h3>Atualização da página disponível, recarregue ou clique aqui!</h3>
                </Button>
            </div>
        );
    }

    return null;
};

export default UpdateBarComponent;
